module.exports = __webpack_public_path__ + "static/Felis-W3-c21ef29e108c82e1468935d144f356c6.webp";